// extracted by mini-css-extract-plugin
export default {"newsfeedCard":"O5-z"};